import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import slugify from 'react-slugify'

const StoreGroup = ({ title, items, hasContent }) => {
  return hasContent ? (
    <div className={`CategoryGroup col-12 pb-3 ${slugify(title, { delimiter: '-' })}`}>
      <h4 className='CategoryParent mb-1'>{title}</h4>
      <div className='CategoryChilds row'>
        {items.map((item, ix) => (

          (process.env.REACT_APP_CATALOG_ID === '40542' ||
            process.env.REACT_APP_CATALOG_ID === '40541' ||
            process.env.REACT_APP_CATALOG_ID === '40540' ||
            process.env.REACT_APP_CATALOG_ID === '40539' ||
            process.env.REACT_APP_CATALOG_ID === '40538' ||
            process.env.REACT_APP_CATALOG_ID === '40543' ||
            process.env.REACT_APP_CATALOG_ID === '40496')
            ? (item.supplierTypeId !== '4') && <div key={ix} className={`col-12 col-md-4 pt-half pl-3 pl-md-1  ${slugify(item.name, { delimiter: '-' })}`}>
              <p>
                <Link
                  to={((item.customUrlPage !== undefined) && (item.customUrlPage !== null) ? item.customUrlPage : `/vendor?vendor=${item.supplierId}`)}
                  className={`txt-body-sm ${item.name === 'CONEXXE TRAVEL' ? 'd-none' : ''}`}
                >
                  {item.name}
                </Link>
              </p>
            </div>
            : <div key={ix} className={`col-12 col-md-4 pt-half pl-3 pl-md-1  ${slugify(item.name, { delimiter: '-' })}`}>
              <p data-supplierId={item.supplierTypeId}>
                <Link
                  to={((item.customUrlPage !== undefined) && (item.customUrlPage !== null) ? item.customUrlPage : `/vendor?vendor=${item.supplierId}`)}
                  className='txt-body-sm'
                >
                  {item.name}
                </Link>
              </p>
            </div>
        ))}
      </div>
    </div>
  ) : (
    ''
  )
}
StoreGroup.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  hasContent: PropTypes.bool.isRequired
}
export default StoreGroup



// WEBPACK FOOTER //
// ./src/features/Store/StoreGroup.js